import { type JSX } from 'react';

import { type Bet } from '../../types';

import { MarketExpanderSimple } from './MarketExpanderSimple';

interface PlayerBettingMarketExpanderProps {
  bets: Array<
    Bet & {
      bestOdds: number;
      bestOddsFractional: string;
      bestOddsText: string | number;
    }
  >;
  marketId: number;
}

export const PlayerBettingMarketExpander = ({ bets }: PlayerBettingMarketExpanderProps): JSX.Element => {
  return <MarketExpanderSimple bets={bets} />;
};
